import { getLiteral } from 'utils/getLiteral';

export const getEditorToolbar = () => {
    let hints;
    const platform = navigator?.userAgentData?.platform || navigator?.platform || 'unknown';
    const MacOrSimilar =
        platform.toUpperCase().includes('MAC') || platform.match(/(Mac|iPhone|iPod|iPad)/i);

    if (MacOrSimilar) {
        hints = {
            b: getLiteral('label_bold_mac_os'),
            i: getLiteral('label_italic_mac_os'),
            u: getLiteral('label_underline_mac_os'),
            del: getLiteral('label_strike_mac_os'),
            ul: getLiteral('label_list_mac_os'),
            ol: getLiteral('label_ordered_list_mac_os'),
        };
    } else {
        hints = {
            b: getLiteral('label_bold'),
            i: getLiteral('label_italic'),
            u: getLiteral('label_underline'),
            del: getLiteral('label_strike'),
            ul: getLiteral('label_list'),
            ol: getLiteral('label_ordered_list'),
        };
    }

    return [
        {
            hint: hints.b,
            item: 'b',
        },
        {
            hint: hints.i,
            item: 'i',
        },
        {
            hint: hints.u,
            item: 'u',
        },
        {
            hint: hints.del,
            item: 'del',
        },
        {
            hint: hints.ul,
            item: 'ul',
        },
        {
            hint: hints.ol,
            item: 'ol',
        },
    ];
};
